/**
 * Disparo de descargas en el browser.
 *
 * Vivía al final de `sources.ts`. Se movió aquí cuando el PDF de
 * artefactos (OT-0027) pasó a ser un segundo consumidor: un helper
 * genérico colgando del módulo de una feature invita a que el siguiente
 * lo copie en vez de importarlo.
 */

/**
 * Dispara el download en el browser usando un Blob URL temporal.
 * Centralizado aquí para que las vistas no dupliquen la lógica.
 */
export function triggerBrowserDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
